var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.$t("PLEASE_PERFORM_QUALITY_CONTROL"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }